import { TouchableOpacity, Image, View } from "react-native";
import React from "react";
import { AppImages } from "../utility/AppImages";

export const SwitchCommon = (props) => {
  const { switchState, setSwitchState, color = "black" } = props;

  // Custom red toggle with only the circle being red
  if (color === "red") {
    return (
      <TouchableOpacity
        onPress={() => {
          setSwitchState(!switchState);
        }}
        style={{
          width: 44,
          height: 24,
          borderRadius: 9999,
          borderWidth: 1,
          borderColor: switchState ? "#DC2626" : "#4B5563",
          backgroundColor: switchState ? "rgba(220, 38, 38, 0.10)" : "rgba(75, 85, 99, 0.20)",
          justifyContent: "center",
          paddingHorizontal: 2,
        }}
      >
        <View
          style={{
            width: 18,
            height: 18,
            borderRadius: 9999,
            backgroundColor: switchState ? "#DC2626" : "#6B7280",
            alignSelf: switchState ? "flex-end" : "flex-start",
          }}
        />
      </TouchableOpacity>
    );
  }

  // Default image-based toggle for black/white
  const getImageSource = () => {
    if (color === "black") {
      return switchState ? AppImages.icSwitchOn : AppImages.icSwitchOff;
    }
    return switchState ? AppImages.icSwitchOnWhite : AppImages.icSwitchOffWhite;
  };

  return (
    <TouchableOpacity
      style={{ height: 27, aspectRatio: 2 }}
      onPress={() => {
        setSwitchState(!switchState);
      }}
    >
      <Image
        source={getImageSource()}
        style={{
          height: 27,
          width: "100%",
          resizeMode: "contain",
        }}
      />
    </TouchableOpacity>
  );
};
